import { Button } from "@mui/material";
import { styled } from '@mui/material/styles';

export const WhiteButton = styled(Button)(() => ({
  color: "#394262;",
  backgroundColor: "#FFFFFF",
  '&:hover': {
    color: "#FFFFFF",
    backgroundColor: "#0B8C3A",

  },
}));


export const GreenButton = styled(Button)(() => ({
    color: "#FFFFFF;",
    backgroundColor: "#0B8C3A",
    '&:hover': {
      color: "#FFFFFF",
      backgroundColor: "#055b24",

    },
  }));